<template>
	<nav>
        
        <ul class="nav-top">
            <li 
            v-for="(app, i) in apps" 
            :key="i"
            :class="[{active: app.active}]">
                <el-tooltip class="item" effect="dark" :content="app.tooltip" placement="right">
                    <a v-if="app.function" href="#" @click="app.function">
                        <i :class="app.icon"></i>
                    </a>
                    <a v-else :href="app.href">
                        <i :class="app.icon"></i>
                    </a>
                </el-tooltip>
            </li>
        </ul>

        <ul class="nav-bottom">
            <li>
                <el-tooltip class="item" effect="dark" content="Cerrar sesión" placement="right">
                    <a href="#" @click="logout()">
                        <i class="el-icon-switch-button" ></i>
                    </a>
                </el-tooltip>
            </li>
        </ul>
    </nav>
</template>

<script>
    import {
        redireccionLogin,
        getUrl
    } from '../api/api.js'

    import {
        url_gestor_archivos
    } from '../config.js'

	export default {
		name: 'Navbar',
		data () {
			return {
                apps: [
                    {
                        href: '/SiDMS.ADM/',
                        icon: 'el-icon-s-operation',
                        active: false,
                        tooltip: 'Administrador'
                    }, {
                        href: '/SiDMS.DOC/',
                        icon: 'el-icon-search',
                        active: false,
                        tooltip: 'Buscar documento'
                    }, {
                        href: '/SiDMS.DRIVE/',
                        icon: 'el-icon-files',
                        active: true,
                        tooltip: 'Documentos'
                    }, {
                        href: '/SiDMS.EXP/',
                        icon: 'el-icon-document-checked',
                        active: false,
                        tooltip: 'Expedientes'
                    }, {
                        href: '/SiDMS.NAV/',
                        icon: 'el-icon-folder-opened',
                        active: false,
                        tooltip: 'Gestor de carpetas'
                    }, {
                        href: '/SiDMS.UPD/',
                        function: () => this.showGestorArchivos(),
                        icon: 'el-icon-document-add',
                        active: false,
                        tooltip: 'Subir archivo'
                    }, {
                        href: '/SiWFW/',
                        icon: 'el-icon-cpu',
                        active: false,
                        tooltip: 'Workflow'
                    }
                ]
			}
		},
        methods: {
            logout () {
                localStorage.removeItem('accessToken_appficha')
                redireccionLogin()
            },
            showGestorArchivos() {
                localStorage.removeItem('server')
                localStorage.setItem('server', getUrl())
                this.openwindow(url_gestor_archivos, '_blank')
            }
        }
	}
</script>

<style lang="scss">
nav {
    background-color: #ffffff;
    border-right: 1px solid #dcdfe6;
    display: flex;
    flex-flow: column;
    justify-content: space-between;

    ul {
        list-style: none;
        padding: 0px;
        margin: 0px;

        
        li {
            margin-bottom: 10px;
            width: 50px;
            height: 50px;
            overflow: hidden;
            font-size: 23px;
            border-left: 4px solid white;

            &.active {
                border-left: 4px solid $--color-header;
                a {
                    color: $--color-header!important;
                }
            }
            a {
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                text-decoration: none;
                color: #60626691;
                &:hover {
                    background-color:#fafafa;
                    color: #606266;
                }
            }
        }

        &.nav-bottom {
            li:last-child {
                margin-bottom: 0px;
            }
        }
    }
}
</style>
